import React from "react";
import PropTypes from "prop-types";

import ValidationTree
    from "../validationtree/containers/ValidationTreeContainer";
import ActiveFormStore from "data/ActiveFormStore";
import Dispatcher from "Dispatcher";
import ActiveFormActions from "data/ActiveFormActions";
import NavTabs from "lib/common/navtabs/NavTabs";
import DataDefinitionsContainer
    from "lib/dataentry/lib/datadefinition/DataDefinitionsContainer";
import NavigatorStore from "data/NavigatorStore";
import TableStore from "data/TableStore";
import useFluxStore from "@armus/use-flux-store";

export class InnerSidebarLayout extends React.Component {

    render() {
        const {
            activeTabId,
            setActiveTabId,
            hasActiveRecord,
        } = this.props;
        const tabs = [];
        if (hasActiveRecord) {
            tabs.push({
                id: "definitions",
                name: "Definitions",
                class: "definitions",
            }, {
                id: "validation",
                name: "Validation",
                class: "validation",
            });
        }
        if (tabs.length === 0) return null;
        let actuallyActiveTabId = activeTabId;
        if (tabs.every(t => t.id !== activeTabId)) {
            actuallyActiveTabId = tabs[0].id;
        }
        return (
            <div className={"sidebar"}>
                <div className="navigation" key="tabs">
                    <NavTabs
                        tabs={tabs.map(t => ({
                            ...t,
                            active: t.id === actuallyActiveTabId,
                        }))}
                        doSelect={setActiveTabId}
                    />
                </div>
                <div className="sidebar_content" key="content">
                    <div>
                        {this.renderActive(actuallyActiveTabId)}
                    </div>
                </div>
            </div>
        );
    }

    renderActive(activeTabId) {
        const {
            fluxContext,
        } = this.props;
        switch (activeTabId) {
            case "definitions":
                return <DataDefinitionsContainer fluxContext={fluxContext} />;
            case "validation":
                return <ValidationTree fluxContext={fluxContext} />;
            default:
                console.log("tab", activeTabId);
                return;
        }
    }

}

InnerSidebarLayout.propTypes = {
    activeTabId: PropTypes.string.isRequired,
    setActiveTabId: PropTypes.func.isRequired,
    hasActiveRecord: PropTypes.bool.isRequired,
    fluxContext: PropTypes.string.isRequired,
};

const SidebarLayout = props => {
    const { fluxContext } = props;
    const state = useFluxStore(() => ({
        fluxContext,
        hasActiveRecord: NavigatorStore.getRecordState(fluxContext) != null,
        activeTabId: ActiveFormStore.getActiveSidebarTab(fluxContext),
        setActiveTabId: id => Dispatcher.contextDispatch(fluxContext, {
            type: ActiveFormActions.SELECT_SIDEBAR_TAB,
            id,
        }),
    }), [
        ActiveFormStore,
        NavigatorStore,
        TableStore,
    ], [fluxContext]);
    return <InnerSidebarLayout {...props} {...state} />;
};

SidebarLayout.propTypes = {
    fluxContext: PropTypes.string.isRequired,
};

export default SidebarLayout;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/sidebar/SidebarLayout.js